module.exports = __webpack_public_path__ + "media/images/BC_Partners_logowhite-a4fc172f.png";